import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ColLabel, IButtonTable, IPaginatorTable, ISortTable } from './table.interface';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html'
})
export class TableComponent {
  colLabels: ColLabel[] = [];
  dataSource: any;
  columnsToDisplay: any[] = [];
  public defaultSort: ISortTable;
  public allCheckbox = false;
  public checkBoxChecked: boolean[] = [];
  public dataCheckbox: { index: number, data: any }[] = [];
  public isMoreOpen = false;
  public nameCustomChild: string;
  public rowCustomHeaders: ColLabel[];
  public showButtons = {};
  @Input() set data(data: any) {
    if (data) {
      this.dataSource = data;
      this.checkInitialConfigs();
    } else {
      this.dataSource = [];
    }
  }

  @Input() set colsTable(col: ColLabel[]) {
    if (col) {
      this.colLabels = col;
      this.mapperColumns(col);
      this.checkInitialConfigs();
    }
  }
  @Input() paginatorTable: IPaginatorTable;
  @Input() tableFixed = false;
  @Input() lastBlankRow = false;
  @Input() set rowChildHeaders(row: ColLabel[]) {
    if (row && row.length > 0) {
      this.setRowHeaderChild(row);
    }
  }

  @Output() paginationChange: EventEmitter<object> = new EventEmitter();
  @Output() clickButton: EventEmitter<IButtonTable> = new EventEmitter();
  @Output() sortChange: EventEmitter<ISortTable> = new EventEmitter();
  @Output() dataChecked: EventEmitter<unknown> = new EventEmitter();
  @Output() getChildren: EventEmitter<unknown> = new EventEmitter();

  private mapperColumns(cols: ColLabel[]) {
    const displayedColumns: any[] = [];
    cols.forEach((value: ColLabel) => {
      if (!value.hidden) {
        displayedColumns.push({
          label: value.label,
          field: value.field,
          fieldClass: value.fieldClass,
          action: value.action,
          nameIcon: value.nameIcon,
          nameSecondIcon: value.nameSecondIcon,
          sort: value.sort,
          columnClass: value.columnClass,
          hiddenIcon: value.hiddenIcon,
          expanded: false,
          conditional: value.conditional,
          expandedCustomChild: false,
        });
        if (value.sortDirection) {
          this.defaultSort = { ColumnOrder: value.field[ 0 ], OrderDirection: value.sortDirection };
        }
      }
    });
    this.columnsToDisplay = [ ...displayedColumns ];
    this.nameCustomChild = this.columnsToDisplay.find(
      col => col.columnClass === 'buttonFixed' && (col.action === 'expand' || col.action === 'expandWithCall') && col.field[ 0 ] !== ''
    )?.field[ 0 ];
    this.setRowHeaderChild();
  }

  private checkInitialConfigs(): void {
    if (this.dataSource && this.dataSource.length > 0 && this.columnsToDisplay && this.columnsToDisplay.length > 0) {
      const buttonsHidden = this.columnsToDisplay.filter(val => val.fieldClass[ 0 ] === 'buttonRowHidden');
      buttonsHidden.forEach((btnHidden) => {
        const conditionalColumn = btnHidden.field[ 0 ];
        this.showButtons[ conditionalColumn ] = {};
        this.dataSource.forEach((val, i) => {
          this.showButtons[ conditionalColumn ][ i ] = val[ conditionalColumn ];
        });
      });
      if (this.columnsToDisplay.find(val => val.fieldClass === 'checkInput')) {
        this.checkBoxChecked = new Array(this.dataSource.length).fill(false);
        this.dataCheckbox = [];
        this.allCheckbox = false;
      }
    }
  }

  private setRowHeaderChild(rowHeader?: ColLabel[]): void {
    if (rowHeader) {
      this.rowCustomHeaders = rowHeader;
    }
    if (this.rowCustomHeaders?.length > 0 && this.columnsToDisplay?.length > 0) {
      const emptyCols = {
        label: '',
        field: [ '' ],
        fieldClass: [ '' ],
        action: '',
      };
      const arrAux = new Array(this.columnsToDisplay.length - this.rowCustomHeaders.length).fill(emptyCols);
      this.rowCustomHeaders = [ ...this.rowCustomHeaders, ...arrAux ];
    }
  }

  public moreClicked(item): void {
    item.expanded = !item.expanded;
  }

  public handleExpand(type: string, data: unknown): void {
    this.isMoreOpen = !this.isMoreOpen;
    this.clickButton.emit({ column: type, data });
  }

  public handlePagination(event: PageEvent): void {
    if (event.pageSize !== this.paginatorTable.pageSize) {
      this.paginationChange.emit({ PageNumber: 1, NumOfElements: event.pageSize });
    } else {
      this.paginationChange.emit({ PageNumber: event.pageIndex + 1, NumOfElements: event.pageSize });
    }
  }

  public handleButton(type: string, data: unknown): void {
    this.clickButton.emit({ column: type, data });
  }

  public sortData(event: Sort): void {
    this.sortChange.emit({ ColumnOrder: event.active, OrderDirection: event.direction });
  }

  public checkedData(index: number, data: unknown): void {
    if (this.dataCheckbox?.some(value => value.index === index)) {
      this.dataCheckbox = this.dataCheckbox.filter(value2 => value2.index !== index);
      this.checkBoxChecked[ index ] = false;
    } else {
      this.dataCheckbox.push({ index, data });
      this.checkBoxChecked[ index ] = true;
    }
    const dataSend = this.dataCheckbox.map(res => res.data);
    this.allCheckbox = dataSend.length === this.dataSource.length;
    this.dataChecked.emit(dataSend);
  }

  public checkedAllData(event: boolean): void {
    this.allCheckbox = event;
    this.checkBoxChecked = this.checkBoxChecked.map(() => this.allCheckbox);
    this.dataCheckbox = this.allCheckbox ? this.dataSource.map((value, index) => ({ index, data: value })) : [];
    this.dataChecked.emit(this.allCheckbox ? this.dataSource : []);
  }

  public isWarnedRow(rowInfo): boolean {
    return rowInfo.noRead;
  }

  public getMoreClicked(item): void {
    item.expanded = !item.expanded;
    if (item.expanded) {
      this.getChildren.emit(item);
    } else {
      this.getChildren.emit(null);
    }
  }
}
